import createReactComponent from '../createReactComponent';
export default createReactComponent('squares-diagonal', 'IconSquaresDiagonal', [
  [
    'path',
    {
      d: 'M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z',
      key: 'svg-0',
    },
  ],
  [
    'path',
    {
      d: 'M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2',
      key: 'svg-1',
    },
  ],
  ['path', { d: 'M8.586 19.414l10.827 -10.827', key: 'svg-2' }],
]);
